import { useState, useRef, useCallback } from "react";
import { FaCheck, FaTimes, FaChevronDown } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import PortalDropdown from "./PortalDropdown";

const RsvpDropdown = ({ guest, onSelect }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const handleClose = useCallback(() => setOpen(false), []);

    const getLabel = () => {
        if (!guest.rsvpDate) return { text: 'Na čekanju', color: 'text-gray-500', dot: 'bg-gray-400' };
        if (guest.isAttending) return {
            text: guest.rsvpSetBy === 'admin' ? 'Dolazi (admin)' : 'Dolazi (gost)',
            color: 'text-green-700', dot: 'bg-green-500',
        };
        return {
            text: guest.rsvpSetBy === 'admin' ? 'Ne dolazi (admin)' : 'Ne dolazi (gost)',
            color: 'text-red-600', dot: 'bg-red-400',
        };
    };

    const label = getLabel();

    return (
        <div ref={anchorRef}>
            <button
                onClick={() => setOpen(o => !o)}
                className="w-full flex items-center justify-between gap-2 px-3 py-2 bg-white border border-gray-200 rounded-xl text-sm text-gray-700 hover:border-rose-300 hover:bg-rose-50 transition-all"
            >
                <span className="flex items-center gap-2">
                    <span className={`w-2 h-2 rounded-full flex-shrink-0 ${label.dot}`} />
                    <span className={`truncate text-xs font-medium ${label.color}`}>{label.text}</span>
                </span>
                <FaChevronDown className={`text-xs text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>
            <PortalDropdown anchorRef={anchorRef} open={open} onClose={handleClose}>
                <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden min-w-[180px]">
                    <button
                        onMouseDown={() => { onSelect(guest._id, true); setOpen(false); }}
                        className={`w-full flex items-center gap-2 px-4 py-2.5 text-sm text-left hover:bg-green-50 transition border-b border-gray-50 ${guest.isAttending && guest.rsvpDate ? 'font-semibold text-green-700 bg-green-50' : 'text-gray-700'}`}
                    >
                        <FaCheck className="text-green-500 text-xs" /> Dolazi
                    </button>
                    <button
                        onMouseDown={() => { onSelect(guest._id, false); setOpen(false); }}
                        className={`w-full flex items-center gap-2 px-4 py-2.5 text-sm text-left hover:bg-red-50 transition border-b border-gray-50 ${guest.rsvpDate && !guest.isAttending ? 'font-semibold text-red-600 bg-red-50' : 'text-gray-700'}`}
                    >
                        <FaTimes className="text-red-500 text-xs" /> Ne dolazi
                    </button>
                    {guest.rsvpDate && (
                        <button
                            onMouseDown={() => { onSelect(guest._id, null); setOpen(false); }}
                            className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-left text-gray-400 hover:bg-gray-50 transition"
                        >
                            <FiX className="text-xs" /> Resetiraj
                        </button>
                    )}
                </div>
            </PortalDropdown>
        </div>
    );
};

export default RsvpDropdown;
